import {Box, Container, styled} from '@mui/material';
import {CTAButtonFixed} from 'presentation/components';

export const CustomContainer = styled(Container)`
	margin-top: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin-top: 24px;
	}
`;

export const CustomButtonFixedAction = styled(CTAButtonFixed.Action)`
	padding: 8px 22px;
	width: 100%;
`;

export const StyledFooterContainer = styled(Box)`
	margin: auto 0px 164px;
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;
